// QA override for the repeat-donor tip experiment: ?repeat_donor_experiment=a|b|c|d|e|f|g forces the variant end to end.
export const REPEAT_DONOR_EXPERIMENT_QUERY_PARAM = "repeat_donor_experiment";

export const REPEAT_DONOR_EXPERIMENT_FORCEABLE_VARIANTS = ["a", "b", "c", "d", "e", "f", "g"] as const;

export type RepeatDonorForceableVariant = (typeof REPEAT_DONOR_EXPERIMENT_FORCEABLE_VARIANTS)[number];

export const getForcedRepeatDonorVariant = (value: string | null | undefined): RepeatDonorForceableVariant | null => {
  const normalized = value?.toLowerCase();
  return REPEAT_DONOR_EXPERIMENT_FORCEABLE_VARIANTS.find((variant) => variant === normalized) ?? null;
};
